/**
 * Tests if a given value is Undefined or Null
 *
 * @function isUndefinedOrNull
 * @param {any} input Value to test
 * @returns {boolean}
 * @category Types
 */
export default function isNotUndefinedOrNull(input) {
  return input !== null && typeof input !== 'undefined';
}
